// @core/api/endpoints/payment/test_payment_provider.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  TestPaymentProviderRequest,
  TestPaymentProviderResponse,
} from '../../../types/payment';

const BASE_PATH = '/payment';

/**
 * Test payment provider connection
 * Tests connectivity and authentication with the payment provider API.
 */
export async function TestPaymentProvider(
  id: string,
  data: TestPaymentProviderRequest,
  options?: RequestOptions
): Promise<TestPaymentProviderResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/payment-providers/:id/test`;
  requestPath = requestPath.replace(':id', encodeURIComponent(id));
  const requestOptions = options;
  return client.post<TestPaymentProviderResponse>(requestPath, data, requestOptions);
}
